import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UsersStore from 'Stores/usersStore';
import OtherSettingsStore from 'Stores/otherSettingsStore';
import 'Styles/usersView/deviceInfo.scss';
import LoadView from 'Components/Common/loadView';
import Switcher from 'Components/Common/switcher';
import Popup from "Components/Common/popup";
import ListBox from 'Components/Common/listBox';
import IconsContainer from "Utils/IconsContainer";
import AppStore from 'Stores/AppStore';
import ProductMode from "Utils/ProductMode";
import { GetDateFromString, ShowAlert2 } from 'Utils/CommonFunctions';
import Helper from 'Utils/Helper';
import { DbRequestStatusEnum, PushStateEnum } from 'Utils/Requests/WebEnums';
import { Link } from 'react-router-dom';

/**
 * @typedef {object} props
 * @property {WebUser} user
 * @property {WebDevice} device
 * @extends {Component<props>}
 */
class DeviceInfo extends Component {

    /** @param {props} props */
    constructor(props) {
        super(props);

        this.userLid = this.props.user.lid;
        this.deviceCode = this.props.device.code;
    }

    /**
     * @param {string | null} dateString 
     * @returns {string}
     */
    getLastLoginDateDescription(dateString) {
        let date = GetDateFromString(dateString);

        if (date)
            return Helper.ToUserFrendlyTimeAndDateString(date);
        else
            return 'Не производилась';
    }

    render() {
        let device = this.props.device;
        if (!device)
            return null;

        let deviceLoadingState = UsersStore.GetDeviceLoadingState(this.userLid, this.deviceCode)

        let { doesRemoving, doesLoggingStateChanging, doesForceResetChanging, doesNotifyNewVersionChanging, doesPushServiceChanging } = deviceLoadingState;

        let os = '';

        UsersStore.deviceTypes.forEach(x => {
            if (x.key === device.type) {
                os = x.value;
            }
        });

        let pushStateText = '';
        let pushStateIcon;
        let pushStateClass = '';
        let isCanSendTestPush = false;

        switch (device.pushState) {
            case PushStateEnum.Ok:
                pushStateText = 'Push-уведомления для данного устройства корректно настроены';
                pushStateIcon = IconsContainer.Get('a-success');
                pushStateClass = 'success';
                isCanSendTestPush = true;
                break;
            case PushStateEnum.PushDisabled:
                pushStateText = 'Устройство получило ключ авторизации push-уведомлений, однако сами уведомления отключены настройками СМР';
                pushStateIcon = IconsContainer.Get('a-warning');
                pushStateClass = 'warning';
                break;
            case PushStateEnum.AuthKeyMissed:
            case PushStateEnum.PushFault:
                pushStateText = 'У устройства отсутствует ключ авторизации push-уведомлений или иная ошибка';
                pushStateIcon = IconsContainer.Get('a-error');
                pushStateClass = 'error';
                if (device.pushState == PushStateEnum.PushFault) {
                    isCanSendTestPush = true;
                }
                break;
            default:
                pushStateText = 'Push-уведомления не настроены';
                pushStateIcon = IconsContainer.Get('a-error');
                pushStateClass = 'error';
                break;
        }

        let dbReqStatus = '';
        let dbReqClass = '';

        switch (device.dbRequestStatus) {
            case DbRequestStatusEnum.Pending:
                dbReqStatus = 'БД запрошена';
                break;
            case DbRequestStatusEnum.Success:
                dbReqStatus = 'БД получена';
                dbReqClass = 'success';
                break;
            case DbRequestStatusEnum.Aborted:
                dbReqStatus = 'Запрос отклонен';
                dbReqClass = 'error';
                break;
            default:
                dbReqStatus = '';
        }

        let userState = this.props.user.state;

        let notActive = AppStore.isMeeting
            ? userState?.blockedReasons?.meetingNotActive
            : userState?.blockedReasons?.docNotActive;
        let requestDeviceDbAvailable = notActive == false;
        let downloadDeviceDbAvailable = UsersStore.GetDeviceDbDumps(this.deviceCode).length > 0;

        let pushProviders = UsersStore.pushProvidersByDeviceTypes[device.type];

        let deviceCodeToShow =
            device.osAuth
                ? this.deviceCode.toUpperCase()
                : this.deviceCode;

        let deviceSettingLinesForCheckVisibility = [
            <div
                key="device-code-and-delete"
                className="device-setting-information"
            >
                <div className="device-setting-title">Код устройства:</div>
                <div className="device-code-value device-setting-value">
                    <span>
                        {deviceCodeToShow}
                    </span>

                    <button
                        className='transparent-button'
                        onClick={() => {
                            if (navigator.clipboard == undefined) {
                                ShowAlert2({ type: 'error', text: 'Код устройства не скопирован. Буфер обмена недоступен.' });
                                return;
                            }

                            navigator.clipboard.writeText(deviceCodeToShow).then(
                                () => {
                                    ShowAlert2({ type: 'success', text: 'Код устройства успешно скопирован.' });
                                },
                                () => {
                                    ShowAlert2({ type: 'error', text: 'Код устройства не скопирован. Буфер обмена недоступен.' });
                                });
                        }}>
                        {IconsContainer.Get('copy')}
                    </button>
                </div>
                <button
                    style={{ visibility: 'hidden' }}
                    className={"device-info-right-button " + (device.withUID ? "disabled" : "")}
                    onClick={() => UsersStore.ShareCode(this.deviceCode)}
                >
                    Поделиться
                </button>
            </div>
            ,
            <div
                key="device-os"
                className="device-setting-information"
            >
                <span className="device-setting-title">Операционная система:</span>
                <span className="device-type-value device-setting-value">{os}</span>
                <button
                    className={"device-info-right-button red-button " + (device.osAuth ? "disabled" : "")}
                    onClick={() => UsersStore.RemoveDevice(this.props.user, this.props.device)}
                >
                    Удалить устройство
                </button>
            </div>
            ,
            <div
                key="device-lastLoginDate"
                className="device-setting-information">
                <span className="device-setting-title">Последняя синхронизация:</span>
                <span className="device-text-value device-setting-value">{this.getLastLoginDateDescription(device.lastLoginDate)}</span>

                <div className="device-request-db">
                    {
                        device.hasTraceKeys ?
                            <button onClick={() => UsersStore.ChangeTraceKeys(this.deviceCode, '', this.userLid)}>
                                Остановить
                            </button>
                            :
                            AppStore.isMeeting ?
                                <button onClick={() => UsersStore.ChangeTraceKeys(this.deviceCode, 'All', this.userLid)}>
                                    Логи
                                </button>
                                :
                                <Link to={`${window.SmrLocation}/users/deviceTrace?deviceId=${this.props.device.id}`}>
                                    <button>
                                        Логи
                                    </button>
                                </Link>
                    }

                    <button className={"download-db " + ((device.isHasClientLogs != true) ? "disabled" : "")}
                        onClick={() => UsersStore.ExportClientLogs(device.logsFromClientDeviceFolderName)}>
                        Выгрузить
                    </button>
                </div>
            </div>
            ,
            <div
                key="device-appVersion"
                className="device-setting-information"
            >
                <span className="device-setting-title">Версия клиента:</span>
                <span className="device-text-value device-setting-value">{device.appVersion}</span>

                <div className='device-info-right-button'>
                    {device.hasTraceKeys ? 'Логирование запущено' : ''}
                </div>
            </div>
            ,
            (os === 'iOS' || os === 'Android' ? (
                <div
                    key="device-notifyNewVersion"
                    className="device-setting-information-without-right-container">
                    <span className="device-setting-title">Уведомить пользователя о появлении новой версии:</span>
                    <div className="device-setting-value switcher-value">
                        <Switcher currentState={device.notifyNewVersion}
                            changed={() => UsersStore.ChangeNotifyNewVersionState(this.deviceCode, !device.notifyNewVersion, this.userLid)} className={(doesNotifyNewVersionChanging ? " disabled" : "")} />
                        {doesNotifyNewVersionChanging ? <LoadView loading={true} /> : <div className="filler" />}
                    </div>
                </div>
            ) : null)
            ,
            <div
                key="device-forceReset"
                className="device-setting-information"
                style={{ marginBottom: dbReqStatus != '' ? "10px" : null }}
            >
                <span className="device-setting-title">Сброс базы данных:</span>
                <div className="device-setting-value switcher-value">
                    <Switcher currentState={device.forceReset}
                        changed={() => UsersStore.ChangeForceResetDevice(this.deviceCode, !device.forceReset, this.userLid)}
                        className={(doesForceResetChanging ? " disabled" : "")} />
                    {doesForceResetChanging ? <LoadView loading={true} /> : <div className="filler" />}
                    {(dbReqStatus != '' ? (
                        <div key="device-request-db" className={"device-request-db-status-text-container " + dbReqClass}>
                            <span>{dbReqStatus}</span>
                        </div>
                    ) : null)}
                </div>
                <div className="device-request-db">
                    <button className={"request-db " + (requestDeviceDbAvailable ? null : "disabled")} onClick={() => UsersStore.RequestClientDbSetStatusPending(this.deviceCode, this.userLid)}>Запросить БД</button>
                    <button className={"download-db " + (downloadDeviceDbAvailable ? null : "disabled")} onClick={() => UsersStore.ShowDeviceDbModal(this.deviceCode)}>Выгрузить БД</button>
                </div>
            </div>
            ,
            <div
                key="device-pushState"
                className="device-setting-information">
                <span className="device-setting-title">Состояние push-уведомлений для устройства:</span>
                <div className="device-setting-value push-state">
                    <Popup popupText={pushStateText}
                        className={'fast-info-popup ' + pushStateClass}>
                        {pushStateIcon}
                    </Popup>
                </div>
                <button
                    className={"device-info-right-button " + ((isCanSendTestPush == false || UsersStore.testPushAlertSending) ? "disabled" : "")}
                    onClick={() => UsersStore.SendTestPushAlert(this.deviceCode)}
                >
                    Отправить тестовое уведомление
                </button>
            </div>
            ,
            (pushProviders.length == 0 ? null : (
                <div
                    key="device-pushProvider"
                    className="device-setting-information-without-right-container">
                    <span className="device-setting-title">Сервис push-уведомлений для устройства:</span>
                    <div className="device-setting-value">
                        <ListBox
                            values={pushProviders}
                            selectedItem={device.pushProvider}
                            onSelectedItemChanged={(val) => UsersStore.ChangePushService(this.deviceCode, val, this.userLid)} />
                        {doesPushServiceChanging ? <LoadView loading={true} /> : <div className="filler" />}
                    </div>
                </div>
            ))
            ,
            (pushProviders.length == 0 ? null : (
                <div
                    key="device-pushLastRegistrationDate"
                    className="device-setting-information-without-right-container">
                    <span className="device-setting-title">Последнее push-уведомление было отправлено:</span>
                    <span className="device-text-value device-setting-value">{device.lastPushRegistration ? Helper.ToUserFrendlyTimeAndDateString(device.lastPushRegistration) : "Нет данных"}</span>
                </div>
            ))
        ];

        let deviceSettingLines = ProductMode.FilterControlsParamsObject({
            webKeysVisible: AppStore.productModeSettings?.filterUserDeviceSettingsWebKeysVisible,
            controlsForFiltering: deviceSettingLinesForCheckVisibility
        });

        return (
            <div
                key={"deviceInfo-" + this.deviceCode}
                className={"full-device-info " + (doesRemoving ? ' disabled' : '')}>
                <div className="device-info">
                    {deviceSettingLines}
                </div>
            </div>
        )
    }
}

export default observer(DeviceInfo);